import React from "react";

const GATEWAY_META = {
    Razorpay: {
        accent: "indigo",
        icon: (
            <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
                <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" />
            </svg>
        ),
    },
    Stripe: {
        accent: "violet",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-5 w-5">
                <rect x="2" y="5" width="20" height="14" rx="2" />
                <path d="M2 9.5h20" />
            </svg>
        ),
    },
    PayPal: {
        accent: "sky",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" className="h-5 w-5">
                <path d="M6 4h7a4 4 0 0 1 4 4.6c-.5 3-3 4.9-6.2 4.9H8.4L7 20H4L6 4z" />
            </svg>
        ),
    },
    Active: {
        accent: "emerald",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" className="h-5 w-5">
                <path d="M12 2v9" />
                <path d="M6.5 6.5a7 7 0 1 0 11 0" />
            </svg>
        ),
    },
};

const ACCENT = {
    indigo: { border: "border-indigo-500", bg: "bg-indigo-50", iconBg: "bg-indigo-100", iconText: "text-indigo-600", switchOn: "bg-indigo-600" },
    violet: { border: "border-violet-500", bg: "bg-violet-50", iconBg: "bg-violet-100", iconText: "text-violet-600", switchOn: "bg-violet-600" },
    sky: { border: "border-sky-500", bg: "bg-sky-50", iconBg: "bg-sky-100", iconText: "text-sky-600", switchOn: "bg-sky-600" },
    emerald: { border: "border-emerald-500", bg: "bg-emerald-50", iconBg: "bg-emerald-100", iconText: "text-emerald-600", switchOn: "bg-emerald-600" },
};

const GatewayToggleCard = ({
    title,
    description,
    checked,
    onChange,
}) => {
    const meta = GATEWAY_META[title] || GATEWAY_META.Active;
    const accent = ACCENT[meta.accent];

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onChange}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onChange()}
            className={`group flex cursor-pointer select-none items-center justify-between gap-4 rounded-2xl border p-4 transition-all duration-200
                ${checked ? `${accent.border} ${accent.bg} shadow-sm` : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"}`}
        >
            <div className="flex min-w-0 items-center gap-3">
                <div
                    className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl transition-colors
                        ${checked ? `${accent.iconBg} ${accent.iconText}` : "bg-slate-100 text-slate-400 group-hover:text-slate-500"}`}
                >
                    {meta.icon}
                </div>

                <div className="min-w-0">
                    <h4 className="truncate font-semibold text-slate-800">{title}</h4>
                    <p className="truncate text-sm text-slate-500">{description}</p>
                </div>
            </div>

            <div
                className={`relative h-6 w-11 shrink-0 rounded-full transition-colors duration-200 ${checked ? accent.switchOn : "bg-slate-200"}`}
            >
                <span
                    className={`absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200 ${checked ? "translate-x-5" : "translate-x-0"}`}
                />
            </div>
        </div>
    );
};

export default GatewayToggleCard;